import { useState, useMemo, useEffect } from "react";

export default function Pagination({ totalRow, onPageChange, resetVal, hideText }: any) {
    let [pageSize, setPageSize] = useState(10);
    let [pageNumber, setPageNumber] = useState(1);

    const totalPages = useMemo(() => Math.ceil(totalRow / pageSize), [totalRow, pageSize]);

    const windowStart = Math.floor((pageNumber - 1) / 3) * 3 + 1;
    const pageButtons = [windowStart, windowStart + 1, windowStart + 2].filter(
        (n) => n <= totalPages
    );


    useEffect(() => {
        if (resetVal) {
            pageNumber = 1;
            setPageNumber(pageNumber)

            pageSize = 10;
            setPageSize(pageSize)
        }
    }, [resetVal]);

    const goToPage = (n: number) => {
        if (n < 1 || n > totalPages) return;
        setPageNumber(n);
    };

    useEffect(() => {
        onPageChange({ pageNumber, pageSize });

    }, [pageNumber, pageSize]);

    return (
        <div className="ws-12 newPagination mt pagination-wrapper">

            <div className={hideText ? "w-70 pt" : "w-60"}>
                <button className="text-sl m1 pull-right text-bold" onClick={() => goToPage(totalPages)}>Last</button>
                <button className="text-sl m1 pull-right text-bold" onClick={() => goToPage(pageNumber + 1)}>Next</button>

                {windowStart + 3 <= totalPages && (
                    <button className="dots m1 borderNone pull-right text-bold" onClick={() => goToPage(windowStart + 3)}>
                        ...
                    </button>
                )}

                {pageButtons.sort((a, b) => b - a).map((num) => (
                    <button key={num} className={num === pageNumber ? "is-active pull-right text-bold m1" : "pull-right text-bold borderNone m1"} onClick={() => goToPage(num)} >
                        {num}
                    </button>
                ))}

                {windowStart > 1 && (
                    <button className="dots m1 pull-right borderNone text-bold" onClick={() => goToPage(windowStart - 1)}>
                        ...
                    </button>
                )}

                <button className="m1 text-sl pull-right text-bold" onClick={() => goToPage(pageNumber - 1)}> Prev</button>
                <button className="m1 text-sl pull-right text-bold" onClick={() => goToPage(1)}>First</button>
            </div>

            <div className="w-35">

                <div className="ws-12">

                    <div className="ws-2" >
                        <select className="page-size height30" value={pageSize} onChange={(e) => { setPageSize(Number(e.target.value)); setPageNumber(1); }}  >
                            {[10, 20, 50, 100].map((size) => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                    </div>

                    {!hideText && <span className="pll  text-bold text-sl mt ws-9">
                        Showing page {pageNumber} of {totalPages} ({totalRow} Items)
                    </span>}
                </div>
            </div>

        </div>
    );
}